<p-iconfield class="w-100">
    @if (!onSearching) {
        <p-inputicon styleClass="pi pi-search" />
    }
    @else {
        <p-inputicon styleClass="pi pi-spinner pi-spin" />
    }
    <input type="text" pInputText (keyup)="filterChanged.emit($event.target.value)" [placeholder]="placeholder" />
</p-iconfield>
